'use client'
import { useSelect } from 'downshift'
import { ChevronDown, ChevronUp } from 'lucide-react'

const CustomSelectField = ({
  isBoldSelectedOption = false,
  selectedItemClassName = '',
  innerContainerClassName = '',
  containerClassName = '',
  options,
  initialSelectedTitle = '',
  ...field
}) => {
  const itemToString = (item) => {
    return item.title
  }
  const {
    isOpen,
    selectedItem,
    getToggleButtonProps,
    getMenuProps,
    getItemProps,
    highlightedIndex,
  } = useSelect({
    items: options,
    itemToString,
    initialSelectedItem: initialSelectedTitle
      ? initialSelectedTitle
      : options[0],
    initialHighlightedIndex: 0,
    onSelectedItemChange: ({ selectedItem }) => {
      field.onChange(selectedItem?.title)
    },
  })
  return (
    <div>
      <div
        className={`w-full relative flex flex-col gap-1 ${
          containerClassName ? containerClassName : ''
        }`}
      >
        <div
          className={`px-[0.75em] flex items-center ${
            innerContainerClassName ? innerContainerClassName : ''
          } justify-between border py-[9.5px] cursor-pointer focus:outline-none rounded-[5px] w-full font-normal hover:border-[#000] duration-500 ease-in-out transition-all text-[16px] md:text-[14px] border-[#0000001f]`}
          {...getToggleButtonProps()}
        >
          <span
            className={`${isBoldSelectedOption ? 'font-normal'  : 'font-light font-sans'} ${
              selectedItemClassName && selectedItemClassName
            }`}
          >
            {selectedItem ? selectedItem.title : ''}
          </span>
          <span>
            {isOpen ? (
              <ChevronUp color='#a79779' size={17} />
            ) : (
              <ChevronDown color='#757575' size={17} />
            )}
          </span>
        </div>
        <ul
          className={`absolute w-full z-100 rounded-[4px] text-[14px] shadow-dropdown-shadow bg-white top-full mt-2 left-0 overflow-auto z-10 ${
            !isOpen && 'hidden'
          }`}
          {...getMenuProps()}
        >
          {isOpen &&
            options.map((item, index) => (
              <li
                className={`
                    ${
                      selectedItem.tile === item.title ||
                      initialSelectedTitle.title === item.title
                        ? 'bg-[#0000001f]'
                        : highlightedIndex === index
                        ? 'bg-[#0000000a]'
                        : 'bg-inherit'
                    }
                    h-[3em]  cursor-pointer flex items-center px-[10px]
                  `}
                key={item.title}
                {...getItemProps({ item, index })}
              >
                <span className='text-[16px] md:text-[14px]'>{item.title}</span>
              </li>
            ))}
        </ul>
      </div>
    </div>
  )
}

export default CustomSelectField
